import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

export default function PoliticaPrivacidadPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#544E13] mb-8">Política de privacidad</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg mb-6">
              Última actualización: {new Date().toLocaleDateString('es-ES')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Responsable del tratamiento</h2>
              <p className="mb-4">
                RESTAURAX es el responsable del tratamiento de los datos personales del usuario y le informa que 
                estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679 de 27 de 
                abril de 2016 (GDPR) relativo a la protección de las personas físicas en lo que respecta al tratamiento 
                de datos personales y a la libre circulación de estos datos.
              </p>
              <ul className="list-none mb-4">
                <li className="mb-2"><strong>Denominación social:</strong> RESTAURAX</li>
                <li className="mb-2"><strong>Domicilio:</strong> Hospitalet de Llobregat, Barcelona, España</li>
                <li className="mb-2"><strong>Email:</strong> info@restaurax.com</li>
                <li className="mb-2"><strong>Teléfono:</strong> 690 22 09 44</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Finalidades del tratamiento</h2>
              <p className="mb-4">
                Los datos personales que nos proporcione serán tratados con las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Gestionar las consultas realizadas a través del formulario de contacto</li>
                <li>Proporcionar información sobre nuestros servicios de limpieza y restauración post incendio</li>
                <li>Elaborar presupuestos personalizados</li>
                <li>Gestionar la prestación de servicios contratados</li>
                <li>Cumplir con las obligaciones legales aplicables</li>
                <li>Enviar comunicaciones comerciales sobre nuestros servicios (solo con su consentimiento)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Base legal</h2>
              <p className="mb-4">
                El tratamiento de sus datos se basa en las siguientes bases legales:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales</li>
                <li><strong>Ejecución de un contrato:</strong> Para la prestación de servicios solicitados</li>
                <li><strong>Interés legítimo:</strong> Para responder a consultas y proporcionar información</li>
                <li><strong>Cumplimiento de obligaciones legales:</strong> Para cumplir con la normativa aplicable</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Categorías de datos</h2>
              <p className="mb-4">
                Las categorías de datos que tratamos son:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Datos identificativos (nombre, apellidos, DNI/NIE)</li>
                <li>Datos de contacto (dirección, teléfono, email)</li>
                <li>Datos económicos y de transacciones (para facturación)</li>
                <li>Datos de navegación (cookies, IP, dispositivo utilizado)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Conservación de datos</h2>
              <p className="mb-4">
                Los datos personales proporcionados se conservarán:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Mientras se mantenga la relación comercial</li>
                <li>Durante los años necesarios para cumplir con las obligaciones legales</li>
                <li>Hasta que solicite su supresión cuando sea técnica y legalmente posible</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Destinatarios</h2>
              <p className="mb-4">
                Sus datos podrán ser comunicados a:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Organismos públicos cuando sea obligatorio por ley</li>
                <li>Proveedores de servicios que nos ayuden en la prestación de nuestros servicios</li>
                <li>Entidades financieras para la gestión de pagos</li>
                <li>Compañías de seguros cuando sea necesario</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Derechos del usuario</h2>
              <p className="mb-4">
                El usuario tiene derecho a:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li><strong>Acceso:</strong> Solicitar información sobre qué datos tratamos</li>
                <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos</li>
                <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos</li>
                <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento</li>
                <li><strong>Portabilidad:</strong> Solicitar la transferencia de sus datos</li>
                <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos</li>
                <li><strong>Revocación:</strong> Retirar el consentimiento prestado</li>
              </ul>
              <p className="mb-4">
                Para ejercer estos derechos, puede contactarnos en info@restaurax.com o en el teléfono 690 22 09 44.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Reclamaciones</h2>
              <p className="mb-4">
                Si considera que el tratamiento de sus datos personales vulnera la normativa o sus derechos de 
                privacidad, puede presentar una reclamación:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Ante RESTAURAX: info@restaurax.com</li>
                <li>Ante la Agencia Española de Protección de Datos: www.aepd.es</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Seguridad</h2>
              <p className="mb-4">
                RESTAURAX ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad 
                de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, 
                habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos 
                a que están expuestos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Modificaciones</h2>
              <p className="mb-4">
                RESTAURAX se reserva el derecho a modificar la presente política para adaptarla a novedades 
                legislativas o jurisprudenciales, así como a prácticas de la industria. En dichos supuestos, 
                anunciará en esta página los cambios introducidos con razonable antelación a su puesta en aplicación.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
}